import { pipe } from "fp-ts/lib/function";
import { array, option } from "fp-ts";

export function transposeValidAttributesListArray<T>(
  arrayOfAttributes: Array<Array<T>>,
  acc: Array<Array<T>> = [],
): Array<Array<T>> {
  /*
      The idea is to transpose a matrix of n properties for m products into
      n rows of m values (for m products)
      so that UI can insert them row by row (instead of column by column)
      to have better alignment
     */
  const headsOpt = pipe(
    arrayOfAttributes.map(arr => pipe(arr, array.head)),
    array.sequence(option.option),
  );

  return pipe(
    headsOpt,
    option.fold(
      () => acc,
      heads => {
        const tails = pipe(
          arrayOfAttributes.map(arr => pipe(arr, array.tail)),
          array.map(a =>
            pipe(
              a,
              option.getOrElseW(() => []),
            ),
          ),
        );

        return transposeValidAttributesListArray(tails, [...acc, heads]);
      },
    ),
  );
}
